// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-ai-interaction-details',
//   standalone: true,
//   imports: [],
//   templateUrl: './ai-interaction-details.component.html',
//   styleUrl: './ai-interaction-details.component.scss'
// })
// export class AiInteractionDetailsComponent {

// }
// import { Component } from '@angular/core};

// @Component({
//   selector: 'app-interaction-details-ai',
//   standalone: true,
//   imports: [],
//   templateUrl: './interaction-details-ai.component.html',
//   styleUrl: './interaction-details-ai.component.scss'
// })
// export class InteractionDetailsAiComponent {

// }

import { APP_BASE_HREF, CommonModule, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  ViewChild,
  Output,
} from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { ConsoleService } from '@app/_core/services/console.service';
import { ExcelService } from '@app/_core/services/excel.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { saveAs as fileSaverSave } from 'file-saver';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { json } from 'stream/consumers';
import { object } from 'underscore';

@Component({
  selector: 'app-ai-interaction-details',
  templateUrl: './ai-interaction-details.component.html',
  styleUrls: ['./ai-interaction-details.component.scss'],
})
export class AiInteractionDetailsComponent implements OnInit {
  public event: EventEmitter<any> = new EventEmitter();
  auditSaved: boolean = false;

  audioSource = '';

  @Input() ID: number;
  @Input()
  queueList: any;
  @Input()
  isAuditor: any = false;
  @Input()
  isManager: any = false;
  @Input()
  isStaffer: any = false;
  @Input()
  isReporter: any = false;
  @Input()
  isCloseable: any;
  @Input()
  interactionId: string = '';
  @Input()
  AuditsurveyID: string = '';
  @Input()
  recentInteractions: boolean = false;
  @Output() OnHide: EventEmitter<any> = new EventEmitter();

  @Input()
  showPath: boolean = true;


  isSurveyExpanded: boolean = false;
  hdrText: string = '';
  btnText: string = '';
  lists: any = [];
  companyCode: any = '';
  clientAbbreviation: any = '';
  interactionDetailedData: any;
  userDetails: any;
  recordingPageNo = 1;
  recordingStatus: boolean = true;
  public recordingDetails: any;
  hasAIData: boolean = false;
  recordingfile: any;
  @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;
  recordingRes: any;
  isRecordLoaded: boolean = false;
  categories: any;
  isSubmitted: boolean = false;
  showAudit: boolean = false;
  auditData: any;
  auditDetails: any;
  filteredAuditArray: any[];
  selectedForm: any;
  selectedType: any;

  isSameAgent: boolean = false;
  auditSurveyForm: FormGroup;
  surveySections: any;
  selectedFieldOption: any;
  selectedTypeArray: any;
  selectedSurveyArray: any;
  newSurveyData: any;
  scoreValueArray: any[] = [];
  scoreValue: any;
  selectedOption: string;
  fieldOptions: any;
  selectedFormFieldOption: any[] = [];
  sectionLabelStatus: string;
  showPoints: boolean = true;
  // zeroPoints: boolean = true;

  checkStatusArray: any[] = [];
  selectedSurvey: any;
  showOpenSurvey: boolean;
  ivrTime: any;
  queueTime: string;
  csrTime: string;
  submittedDate: string;
  startedDate: string;
  queuedDate: string;
  answeredDate: string;
  endedDate: string;
  followUpDate: string;
  updatedSectionsArray: any[] = [];
  saveSectionData: any[] = [];
  surveyPermissions: any;
  surveyID;
  surveyActionID;
  surveyTypeID;
  surveyDefinitionID;
  savedSurveyId;
  saveLabel: any;
  showSaveBtn: boolean = false;
  showSaveDraftBtn: boolean = false;
  showSubmitBtn: boolean = false;
  showDeleteBtn: boolean = false;
  showExportBtn: boolean = false;
  status: boolean;
  savedSurveyRes: any;
  submitLabel: any;
  DeleteLabel: any;
  deleteLabel: any;
  exportLabel: any;
  openAuditResponse: boolean;

  emptySurveys: any;
  emptySections: any;
  showComments: boolean= true;
  textContent: string = '';

  showAudioTab: boolean = false;
  saveCommentData: any;

  isDeleted: boolean = false;
  savedCommentID: any;
  FieldResponseCommentID: any;
  newName: string;
  showSurveyDetails: boolean;
  recordingsArray: any[] = [];
  selectedRecordingValue: any;
  modalRef?: BsModalRef;
  isChecked: any;
  checkCommentsLength: number = 0;
  showRecOptions: boolean = false;
  userEmail: any;
  surveyUserEmail: any;
  hasAuditSurvey: any = null;
  isAudit: boolean = false;
  videoRecordingfile: any;
  videoSource: string = '';
  isVideoRecordLoaded: boolean = false;
  videoRecordingsArray: any = [];
  selectedVideoRec: any;
  showVideoRecOptions: boolean = false;
  showVideoTab: any = false;
  interactionUserData: any;
  interactionUserDataKeys: string[] = [];
  isTranscript: boolean = false;
  isConfirmOverrideOpen = false; 
  isApprovalSuccessOpen = false;
  isMandatoryReviewDialogOpen = false;
  mandatoryReviewSections: any[] = [];
  recordingTab = [
    { name: 'AgentDesktop', label: 'Agent Desktop', isSelected: true, index: 0, show: true },
    { name: 'Audio', label: 'Audio', isSelected: false, index: 1, show: true },
  ];
  selectedTab: string = '';
  showHeader: boolean;
  isNewDisabled: boolean;
  isDeletedSurvey: boolean;
  auditTypes: any = [];
  auditDefinations: any = [];
  existingSurvey: any;
  duplicateSavedSurveyId: any;
  source: 'AIAudits' | 'AIInteractions' = 'AIInteractions';
  auditResponseData: any = {};
  auditScore: any = null;
  auditStatus: any = null;
  aiSurveyRes: any = null;
  aiScoreSubmitted: boolean = false;
  aiSurveyData: any = null;
  saveSurveyTimeout: any;
  constructor(
    private location: Location,
    private securityService: SecurityService,
    private utils: Utils,
    private excelService: ExcelService,
    public bsModalRef: BsModalRef,
    private router: Router,
    private queueService: QueuesService,
    private appService: AppService,
    private webStorageService: WebStorageService,
    private auditorService: AuditorService,
    private managerService: ManagerService,
    private modalService: BsModalService,
    private consoleService: ConsoleService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  async ngOnInit(): Promise<void> {
  
  this.route.queryParams.subscribe(params => {
    if (params['source'] === 'AIAudits') {
      this.source = 'AIAudits';
      this.AuditsurveyID = params['surveyId'];
    }
  });

    // If navigated via route with id param, set interactionId
    console.log('ngOnInit interactionId:', this.interactionId);
    const routeId = this.route.snapshot.paramMap.get('id');
    if (routeId) {
      this.interactionId = routeId;
      // When routed, there won't be a modal ref; ensure bsModalRef is undefined
      //this.bsModalRef = undefined as any;
    }

    // console.log(this.recentInteractions);
    this.isAudit = this.securityService.validateGrant('AuditAgents');
    if ((this.isAudit == true || this.isAudit == false) && this.recentInteractions == true) {
      this.isAudit = false;
    } else if (this.isAudit == true && this.recentInteractions == false) {
      this.isAudit = true;
    } else if (this.isAudit == false) {
      this.isAudit = false;
    }
    let user = this.webStorageService.getItemFromSessionStorage('currentUser');
    let company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { interactionID: this.interactionId, company: company, user: user, source: this.source };
    this.companyCode = localStorage.getItem('companyCode');
    await this.checkAuditSurveyExperience();
    // if (this.hasAuditSurvey == true) {
    //   this.showAudit = true;
    // } else if (this.hasAuditSurvey == false) {
    //   this.showAudit = false;
    // }
    const payload = { interactionID: this.interactionId, company: company, surveyID: this.AuditsurveyID, user: user, source: this.source };
    const aIEvaluationData: any = await lastValueFrom(this.auditorService.GetAIInteractionDetailsById(payload));
    if (aIEvaluationData && aIEvaluationData.Response && aIEvaluationData.Response.Data && aIEvaluationData.Response.Data.length > 0) {
      this.hasAIData = true;
      this.auditResponseData = [];
      aIEvaluationData.Response.Data.forEach(element => {
        this.auditScore = element.Score;
        if(element.Value){
          const parsed = JSON.parse(element.Value);
          const cleaned = this.cleanKeys(parsed);
          this.auditResponseData[element.Name] = cleaned
        }else{
          this.auditResponseData[element.Name] = '';
        }
      });
      this.aiScoreSubmitted = true;
    }else{
      this.aiScoreSubmitted = false;
      this.hasAIData = false;
    }
    //console.log(this.showAudit);
    //console.log(this.isAudit);
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    //console.log(this.clientAbbreviation);
    //console.log(uc);

    // if (this.clientAbbreviation == 'LCP' || this.clientAbbreviation == 'CAC') {
    //   this.showAudit = true;
    // } else if (this.clientAbbreviation == 'QA1') {
    //   this.showAudit = false;
    // }

    this.getAuditDetailsByInteractionId(this.interactionId);

    const res: any = await lastValueFrom(this.auditorService.GetInteractionsDetailById(uc));
    // this.auditorService.GetInteractionsDetailById(uc).subscribe(async res=>{
    // console.log(res);
    if (res) {
      this.interactionDetailedData = res.Response.Data;
      this.interactionUserData = res.Response.Data.UserData;
      this.isTranscript = this.interactionDetailedData.EnablePostCallView;
      if (typeof this.interactionUserData === 'string') {
        this.interactionUserData = JSON.parse(this.interactionUserData);
      }
      if (
        this.interactionUserData &&
        typeof this.interactionUserData === 'object' &&
        !Array.isArray(this.interactionUserData)
      ) {
        this.interactionUserDataKeys = Object.keys(this.interactionUserData);
        this.interactionUserDataKeys = this.interactionUserDataKeys.filter(key => key !== 'Industry');

      }

      if (this.isTranscript) this.appService.SetTranscriptId(this.interactionId, false);

      // this.interactionDetailedData.Submitted = this.utils.convertServerDate(this.interactionDetailedData.Submitted);
      // this.interactionDetailedData.Started = this.utils.convertServerDate(this.interactionDetailedData.Started);
      // this.interactionDetailedData.Queued = this.utils.convertServerDate(this.interactionDetailedData.Queued);
      // this.interactionDetailedData.Answered = this.utils.convertServerDate(this.interactionDetailedData.Answered);
      // this.interactionDetailedData.Ended = this.utils.convertServerDate(this.interactionDetailedData.Ended);
      // this.interactionDetailedData.FollowUpDate = this.utils.convertServerDate(this.interactionDetailedData.FollowUpDate);

      this.interactionDetailedData.HandlingTime =
        this.interactionDetailedData.HandlingTime > 0
          ? this.utils.formatDuration(this.interactionDetailedData.HandlingTime, '', '', '', '')
          : '-';
      this.interactionDetailedData.TotalHoldTime = this.interactionDetailedData.TotalHoldTime
        ? this.utils.formatDuration(this.interactionDetailedData.TotalHoldTime, '', '', '', '')
        : '-';

      this.queueTime = this.interactionDetailedData.Queued
        ? this.utils.formatDuration(
          (Date.parse(this.interactionDetailedData.Answered) || Date.parse(this.interactionDetailedData.Ended)) -
          Date.parse(this.interactionDetailedData.Queued),
          'ms',
          '',
          '',
          ''
        )
        : '-';

      this.ivrTime =
        (this.interactionDetailedData.InteractionType == 'InboundCall' && (this.interactionDetailedData.Queued != null || this.interactionDetailedData.Answered != null))
          ? this.utils.formatDuration(
            (Date.parse(this.interactionDetailedData.Queued) || Date.parse(this.interactionDetailedData.Answered)) -
            Date.parse(this.interactionDetailedData.Started),
            'ms',
            '',
            '',
            ''
          )
          : '-';
      this.csrTime =
        this.interactionDetailedData.InteractionType == 'InboundCall'
          ? this.interactionDetailedData.Answered
            ? this.utils.formatDuration(
              (Date.parse(this.interactionDetailedData.Submitted) > Date.parse(this.interactionDetailedData.Ended)
                ? Date.parse(this.interactionDetailedData.Ended)
                : Date.parse(this.interactionDetailedData.Submitted)) -
              Date.parse(this.interactionDetailedData.Answered),
              'ms',
              '',
              '',
              ''
            )
            : '-'
          : this.utils.formatDuration(
            (Date.parse(this.interactionDetailedData.Submitted) > Date.parse(this.interactionDetailedData.Ended)
              ? Date.parse(this.interactionDetailedData.Ended)
              : Date.parse(this.interactionDetailedData.Submitted)) -
            Date.parse(this.interactionDetailedData.Started),
            'ms',
            '',
            '',
            ''
          );

      this.submittedDate = this.interactionDetailedData.Submitted
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Submitted)
        : '-';
      this.startedDate = this.interactionDetailedData.Started
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Started)
        : '-';
      this.queuedDate = this.interactionDetailedData.Queued
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Queued)
        : '-';
      this.answeredDate = this.interactionDetailedData.Answered
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Answered)
        : '-';
      this.endedDate = this.interactionDetailedData.Ended
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Ended)
        : '-';
      this.followUpDate = this.interactionDetailedData.FollowUpDate
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.FollowUpDate)
        : '-';

      if (this.interactionDetailedData?.Recording && this.interactionDetailedData?.VideoRecording) {
        this.showHeader = true;
        this.selectedTab = 'AgentDesktop';
      } else {
        this.showHeader = false;
      }

      //Audio Recording
      this.recordingfile = this.interactionDetailedData.Recording;
      if (this.recordingfile != null && this.recordingfile.includes('|')) {
        this.recordingsArray = this.recordingfile.split('|');
        //console.log(this.recordingsArray);

        this.recordingsArray = this.recordingsArray.filter(item => item);
        this.selectedRecordingValue = this.recordingsArray[0];
        //console.log(this.selectedRecordingValue);
      } else {
        this.selectedRecordingValue = this.recordingfile;
        this.showRecOptions = false;
      }

      if (this.recordingfile != null && this.recordingfile.length > 0) {
        this.showAudioTab = true;
        this.showRecOptions = true;
        // console.log(this.recordingfile);
        const data = await lastValueFrom(this.managerService.getRecordingFiles(this.selectedRecordingValue));
        // console.log(data);
        if (data) {
          this.selectedTab = this.showHeader ? this.selectedTab : 'Audio';
          this.loadAudioClick(data);
          this.isRecordLoaded = true;
        }
      }

      //Video Recording
      if (this.interactionDetailedData) {
        let videoRecordingPath = this.interactionDetailedData.VideoRecording;
        if (videoRecordingPath) {
          this.videoRecordingsArray = videoRecordingPath.split('|');
          this.showVideoRecOptions = true;
          if (this.videoRecordingsArray && this.videoRecordingsArray.length > 0) {
            this.showVideoTab = true;
            // ONV-6355
          if (!this.showAudioTab) {
            this.showAudioTab = true;
              }
            this.selectedVideoRec = this.videoRecordingsArray[0];
            const videodata = await lastValueFrom(this.managerService.getRecordingFiles(this.selectedVideoRec));
            // console.log(videodata);
            if (videodata) {
              this.selectedTab = this.showHeader ? this.selectedTab : 'AgentDesktop';
              this.loadVideo(videodata);
              this.isVideoRecordLoaded = true;
            }
          }
        }
      }
    }

    this.renderConsoleAccess();
    if (this.queueList && this.queueList.length === 0) {
      var noQueues = 'You do not have any queues at this time';
    } else this.renderView();
  }

  cleanKeys(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.cleanKeys(item));
    }

    if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc: any, key: string) => {
        const newKey = key
          .replace(/[\s_]+/g, '')  // remove space + underscore
          .toLowerCase();          // lowercase

        acc[newKey] = this.cleanKeys(obj[key]);
        return acc;
      }, {});
    }

    return obj; // primitive values
  }
  async checkAuditSurveyExperience() {
    const data: any = await lastValueFrom(this.consoleService.hasAuditSurveyExperience());
    const isValid = ResponseHandler.processResponse(data, 'hasAuditSurveyExperience');
    if (isValid) {
      this.hasAuditSurvey = data.Response.Data;
    }
    // console.log(this.hasAuditSurvey, 'status');
  }
  FollowUpDate(FollowUpDate: any): any {
    throw new Error('Method not implemented.');
  }

  renderConsoleAccess() {
    if (this.isAuditor || this.isManager || this.isStaffer) {
      this.hdrText = (this.isManager || this.isStaffer ? 'Manager' : 'Auditor') + ' Console';

      this.btnText =
        ((this.isManager || this.isStaffer) && this.isAuditor
          ? 'Manage / Audit'
          : this.isManager || this.isStaffer
            ? 'Manage'
            : 'Audit') + ' Agents';
    }
  }
  getHeadingContent(item: any, i: number) {
    return (
      '<h2 class="accordion-header" [id]="\'heading\'' +
      i +
      '"><button class="accordion-button" [ngClass]="{ \'collapsed\': ' +
      i +
      ' != 0 }" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="\'#collapse\'+' +
      i +
      '" [attr.aria-expanded]="' +
      i +
      ' == 0" [attr.aria-controls]="\'collapse\'+' +
      i +
      '"> <span class="menu-item">' +
      item.name +
      ' </span> <span class="count">' +
      item.totalrecords +
      '</span></button></h2>'
    );
  }
  renderView() {
    const currQueueID: any = '';
    let thisList: any = [];
    let finalList: any;
    for (let x = 0; x < this.queueList && this.queueList.length; x++) {
      const q = this.queueList[x];

      if (
        (q.Type == 'Inbound' || q.Type == 'VideoChat' || q.Type == 'TextChat') &&
        q.LinkedQueueCount > 0 &&
        q.HideIfBlended === true
      )
        continue;
      if (this.getFromArray(this.lists, q.Type, 'name') == null) {
        var hdrText;

        hdrText = q.Type.split(/(?=[A-Z])/).join(' ');

        this.lists.push({ name: q.Type, data: [] });

        thisList = this.getFromArray(this.lists, q.Type, 'name');
      } else {
        thisList = this.getFromArray(this.lists, q.Type, 'name');
      }
      let queueItem: any = [];
      let countLabel = null;
      switch (q.Type) {
        case 'Blended':
          var inboundCount = 0;
          for (const i in q.LinkedQueueIDs) {
            const linkedQ = this.getFromArray(this.queueList, q.LinkedQueueIDs[i], 'ID');
            if (linkedQ != null) inboundCount += linkedQ.Items;
          }
          countLabel = inboundCount + '/ ' + q.Items;
          break;
        case 'Inbound':
          countLabel = q.Items;
          break;
        case 'InboundFax':
          countLabel = q.Items;
          break;
        case 'TextChat':
        case 'VideoChat':
          countLabel = q.Items;
          break;
        case 'Outbound':
          countLabel = q.Items;
          break;
        default:
          break;
      }
      queueItem = {
        id: q.ID,
        type: q.Type,
        dialertype: q.DialerType,
        name: q.Name,
        items: q.Items,
        countLabel: countLabel,
        queue: q,
      };

      const index = this.getArrayIndex(this.lists, q.Type, 'name');

      this.lists[index].data.push(queueItem);
      this.lists[index].totalrecords = this.getTotalRecords(this.lists[index]);
    }
  }

  getFromArray(array: any, search: any, propName: any) {
    const index = this.getArrayIndex(array, search, propName);
    if (index != -1) {
      return array[index];
    }
    return null;
  }

  getArrayIndex(array: any, search: any, propName: any) {
    for (let i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  }

  getTotalRecords(item: any) {
    let count = 0;
    for (let i = 0; i < item.data.length; i++) {
      count = count + item.data[i].items;
    }
    return count;
  }

  goToQueue(selectedQueue: any) {
    this.queueService.notifyOtherFromTaskMenu({
      refresh: true,
      menuName: selectedQueue.type,
    });

    this.closeTaskSelectionMenu();
    // console.log('selectedQueue', selectedQueue);
    this.appService.setselectedQueueId(selectedQueue.id);
    localStorage.setItem('qid', selectedQueue.id);
    this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type], {
      queryParams: { qid: selectedQueue.id },
    });
  }
  async closeTaskSelectionMenu() {
    if (this.selectedSurveyArray && this.selectedSurveyArray.length == 0 && this.checkCommentsLength > 0) 
      { 
      const initialState = {
        title: 'Warning: Unsaved Changes Detected',
        contentMsg: 'You have unsaved changes. Would you like to save or discard them?',
        confirmBtnValue: 'Save Changes',
        cancelBtnValue: 'Discard',
        isConfirm: true,
        isDelete: false,
      };
  
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };
  
      this.modalRef = this.modalService.show(ConfirmDialogComponent,config);
  
      this.modalRef.content.event.subscribe(async (result: any) => {
  
        if (result.value == 'confirm') {
          await this.saveSurvey(null, false, null);
        }
  
        this.modalRef?.hide();
  
        this.navigateBack();
      });
  
      return;
    }
  
    this.OnHide.emit();
    this.navigateBack();
  }
  private navigateBack(): void {
    if (this.source === 'AIAudits') 
      {
     this.router.navigate([this.clientAbbreviation + '/Console/Auditing/AIAudits']);
      return;
     }
  
    if (this.router.url.includes('/Performance')) 
       {
      return;
        }
  
    this.router.navigate([this.clientAbbreviation + '/Console/Auditing/AIInteractions']);
  }

  goToConsole() {
    this.closeTaskSelectionMenu();
    this.router.navigate([this.clientAbbreviation + '/Console/Interactions']);
  }

  changeRecording(event) {
    // console.log(event);
    this.isRecordLoaded = false;
    // console.log(this.selectedRecordingValue);
    this.selectedRecordingValue = this.selectedRecordingValue;
    // console.log(this.selectedRecordingValue);
    this.managerService.getRecordingFiles(this.selectedRecordingValue).subscribe(res => {
      // console.log(res);

      if (res) {
        this.loadAudioClick(res);
        this.isRecordLoaded = true;
      }
    });
    // let data = lastValueFrom(this.managerService.getRecordingFiles(this.selectedRecordingValue));
    // console.log(data);
    // if (data) {
    //   this.loadAudioClick(data)
    //   this.isRecordLoaded = true;
    // }
  }
  loadAudioClick(data) {
    const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
    const binary = Utils.convertDataURIToBinary(binaryData);
    const blob = new Blob([binary], { type: data.MimeType });
    const blobUrl = URL.createObjectURL(blob);
    this.audioSource = blobUrl;
    this.recordingDetails = this.audioSource;
  }
  changeVideoRecording(event) {
    this.isVideoRecordLoaded = false;
    this.managerService.getRecordingFiles(this.selectedVideoRec).subscribe(res => {
      // console.log(res);

      if (res) {
        this.loadVideo(res);
        this.isVideoRecordLoaded = true;
      }
    });
  }
  loadVideo(data) {
    const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
    const binary = Utils.convertDataURIToBinary(binaryData);
    const blob = new Blob([binary], { type: data.MimeType });
    const blobUrl = URL.createObjectURL(blob);
    this.videoSource = blobUrl;
    this.videoRecordingfile = this.videoSource;
  }
  onAuditSurvey() {
    this.isSubmitted = true;
  }

  async onSurveyChange(survey: any) {
    let user = this.webStorageService.getItemFromSessionStorage('currentUser');
      let company = this.webStorageService.getItemFromSessionStorage('company');
      const uc = { interactionID: this.interactionId, company: company, user: user, source: this.source, surveyID: survey?.SurveyID };
      const res: any = await lastValueFrom(this.auditorService.GetInteractionsDetailById(uc));
      if (res?.Response?.Data) {
        this.interactionDetailedData.AIReview = res.Response.Data.AIReview;
        this.interactionDetailedData.AIScore = res.Response.Data.AIScore;
      }    
  }

  async getAuditDetailsByInteractionId(interactionID) {
    const res: any = await lastValueFrom(this.auditorService.GetSurveysGroupedByDefinition(interactionID));
    if (res) {
      this.auditData = res.Response.Data;
      // if (res?.Response?.Data?.[1]?.Surveys?.[0]?.Status?.Name === 'Deleted') {
      //   this.isDeletedSurvey = true;
      // } else {
      //   this.isDeletedSurvey = false;
      // }
      // console.log(this.isDeletedSurvey);
      // console.log(this.auditData);
      if (this.auditData && this.auditData.length > 0) {
        this.auditDetails = this.auditData[0];
        // console.log(this.auditDetails);
        // console.log(this.clientAbbreviation);
        this.filteredAuditArray = [];
        if (this.clientAbbreviation == 'BCH') {
          const filteredSurveys =   this.auditData.filter(item => !item.Name.includes('PCH'));
          this.filteredAuditArray = filteredSurveys;
          // this.auditData.forEach(ele => {
          //   // console.log(ele);
          //   if (ele.Name.includes('BCH')) {
          //     //this.filteredAuditArray = [];
          //     this.filteredAuditArray.push(ele);
          //     // console.log(this.filteredAuditArray, 'filteredArray');
          //   }
          // });
        } else {
          this.filteredAuditArray = this.auditData;
        }
        if (this.clientAbbreviation == 'BCH') 
        {
          this.selectedForm = this.filteredAuditArray.length > 1 ? this.filteredAuditArray[1] : this.filteredAuditArray[0];
        } 
        else 
        {
          this.selectedForm = this.filteredAuditArray[0];
        }
        //console.log(this.filteredAuditArray, 'audit array');
        //this.selectedForm = this.filteredAuditArray[1];
        this.selectedTypeArray = this.selectedForm.Types;
        this.selectedType = this.selectedForm.Types[0];
        this.selectedSurveyArray = this.selectedForm.Surveys;
        this.selectedSurvey = this.selectedForm.Surveys[0];
      }
    }
    // console.log(this.filteredAuditArray, 'audit array');
    // console.log(this.selectedType)
    if (this.selectedSurveyArray && this.selectedSurveyArray.length > 0) {
      this.showOpenSurvey = true;
    } else {
      this.showOpenSurvey = false;
    }
    if (this.showOpenSurvey && !this.isDeletedSurvey && this.selectedSurvey?.SurveyID)
    {
      await this.openAuditSurvey();
    }
  }
  getSelectedType(event) {
    if (event?.currentTarget?.options) {
      this.selectedType = this.selectedForm.Types[event?.currentTarget?.options?.selectedIndex];
    }
  }
  changeFormField(event) {
    // console.log(this.selectedForm, 'selectedform');

    this.selectedTypeArray = this.selectedForm.Types;
    this.selectedType = this.selectedForm.Types[0];
    this.selectedSurveyArray = this.selectedForm.Surveys;
    this.selectedSurvey = this.selectedForm.Surveys[0];
    if (this.selectedSurveyArray && this.selectedSurveyArray.length > 0) {
      this.showOpenSurvey = true;
    } else {
      this.showOpenSurvey = false;
    }
  }
  // checkingSurveyWithDefinitionAndType(selectedForm: any, selectedType: any) {
  //   this.selectedSurveyArray.forEach(item => {
  //     this.auditTypes.push(item.Type.Name);
  //     this.auditDefinations.push(item.SurveyDefinitionID);
  //   });
  //   if (
  //     this.auditTypes.includes(selectedType.Name) &&
  //     this.auditDefinations.includes(selectedForm.SurveyDefinitionID)
  //   ) {
  //     return true;
  //   }
  //   return null;
  // }
  checkingSurveyWithDefinitionAndType(selectedForm: any, selectedType: any): any {
    if (!this.selectedSurveyArray?.length || !selectedForm || !selectedType) {
      return undefined;
    }
    // console.log('Looking for match with:');
    // console.log('selectedType:', selectedType?.Name);
    // console.log('selectedForm ID:', selectedForm?.SurveyDefinitionID);

    this.selectedSurveyArray.forEach(item => {
      console.log('Checking item:', {
        type: item?.Type?.Name,
        defID: item?.SurveyDefinitionID,
        status: item?.Status?.Name,
      });
    });

    return this.selectedSurveyArray.find(
      item =>
        item?.Type?.Name === selectedType?.Name &&
        item?.SurveyDefinitionID === selectedForm?.SurveyDefinitionID 
        //&& item?.Status?.Name !== 'Deleted'
    );
  }

  async createNewAuditSurvey(surveyStatus: boolean) {
    const uc1 = { interactionID: this.interactionId, isAISurveyScore: false,isAIData: true, surveyDefinitionID: this.selectedForm.SurveyDefinitionID };
    this.aiSurveyData = await lastValueFrom(this.auditorService.GetSurvey(null,uc1));
    if (surveyStatus && this.selectedType && this.selectedSurvey?.Status?.Name != 'Deleted' && this.selectedSurvey?.SurveyID==null) {
      this.savedSurveyId = undefined;
      this.savedSurveyRes = null;
      this.newSurveyData = null;
      this.surveySections = [];
      this.surveyPermissions = null;
      this.surveyID = null;
      this.showSurveyDetails = false;

      this.surveyTypeID = this.selectedType.ID;
      this.surveyDefinitionID = this.selectedType.SurveyDefinitionID;

      const surveyDefinitionRes: any = await lastValueFrom(
        this.auditorService.GetSurveyDefinition(this.surveyDefinitionID)
      );

      this.newSurveyData = surveyDefinitionRes.Response.Data;
      this.surveySections = JSON.parse(JSON.stringify(this.newSurveyData.Sections));
      this.showSurveyDetails = true;
      this.isSurveyExpanded = true;
    }

    //Filter out deleted surveys before checking for duplicates
    // this.selectedSurveyArray = this.selectedSurveyArray?.filter(survey => survey.Status?.Name !== 'Deleted');

    this.existingSurvey = this.checkingSurveyWithDefinitionAndType(this.selectedForm, this.selectedType);
    console.log('existingSurvey', this.existingSurvey);
    if (
      surveyStatus == true &&
      this.selectedSurveyArray &&
      this.selectedSurveyArray.length > 0 &&
      //this.selectedSurvey?.Status?.Name !== 'Deleted' &&
      this.existingSurvey
    ) {
      const initialState = {
        title: 'Duplicate Survey',
        contentMsg:
          'You already have a survey that uses this form. \n \n' +
          this.selectedSurvey.SurveyID +
          ':' +
          this.selectedForm.Name +
          '-' +
          this.selectedType?.Name +
          '(' +
          this.selectedSurvey.Status.Name +
          ')' +
          '\n \n' +
          '\n \n Would you like to open it?',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          this.selectedSurvey = this.existingSurvey;
          this.openAuditSurvey();
        }
        this.modalRef.hide();
      });
    } else {
      this.showSurveyDetails = true;

      this.isSurveyExpanded = true;
      let user = this.webStorageService.getItemFromSessionStorage('currentUser');
      this.newName = 'New';
      this.userDetails = user;

      console.log(this.savedSurveyId, 'savedSurvey');
      // console.log(this.openAuditResponse, 'vall');
      if (this.savedSurveyId != undefined && !this.duplicateSavedSurveyId) {
        this.newName = '';

        const surveyRes: any = await lastValueFrom(this.auditorService.GetSurvey(this.savedSurveyId,null));
        // console.log(surveyRes, 'surveyRes');

        this.savedSurveyRes = surveyRes.Response.Data;
        this.userDetails = this.savedSurveyRes.User;
        if (user?.UserID == this.userDetails?.UserID) {
          this.isSameAgent = Number(user.UserID) === Number(this.userDetails?.UserID);
        }
        if (this.isSameAgent) {
          this.showSaveDraftBtn = true;
          this.saveLabel = 'Save Changes';
        } else {
          this.showSaveDraftBtn = false;
          this.saveLabel = ''; 
        }
        const surveyPermissionsRes: any = await lastValueFrom(
          this.auditorService.GetSurveyPermissions(this.savedSurveyId)
        );
        this.surveyPermissions = surveyPermissionsRes.Response.Data;
        if (this.openAuditResponse == true) {
          const surveyDefinitionRes: any = await lastValueFrom(
            this.auditorService.GetSurveyDefinition(this.selectedForm.SurveyDefinitionID)
          );
          this.newSurveyData = surveyDefinitionRes.Response.Data;
          this.surveySections = surveyDefinitionRes.Response.Data.Sections;
          this.openAuditResponse = false;
        }
      } else {
        const surveyDefinitionRes: any = await lastValueFrom(
          this.auditorService.GetSurveyDefinition(this.selectedForm.SurveyDefinitionID)
        );
        this.newSurveyData = surveyDefinitionRes.Response.Data;
        this.surveySections = surveyDefinitionRes.Response.Data.Sections;

        const surveyPermissionsRes: any = await lastValueFrom(this.auditorService.GetSurveyPermissions(null));
        this.surveyPermissions = surveyPermissionsRes.Response.Data;
      }

      // console.log(this.surveyPermissions);

      // console.log(this.savedSurveyRes, 'getsurvey');
      //  console.log(surveyRes);

      // if(this.surveyPermissions.SurveyID != null){
      this.surveyID = this.surveyPermissions.SurveyID;
      if (this.surveyID == 0) {
        this.surveyActionID = this.surveyPermissions.Actions[0]?.SurveyActionID;
        this.surveyID = null;
      }
      // }

      this.surveyTypeID = this.selectedType.ID;
      this.surveyDefinitionID = this.selectedForm.SurveyDefinitionID;

      this.isSubmitted = true;
      let sectionTotal = 0;
      let totalSectionPoints = 0;
      this.surveySections.forEach(ele => {
        ele.Points = 0;
        ele.Max = 0;
        ele.FieldGroup.Changes = {};
        ele.FieldGroup.Data = {};
        ele.surveyID = null;
        ele.commentID = 0;
        ele.aiSurveyScore = 0;
        // console.log(`Section: ${ele.Name}, Max: ${ele.Max}, Points: ${ele.Points}`);
        // if(this.aiSurveyRes?.Response?.Data){
        //   ele.aiSurveyScore = this.aiSurveyRes.Response.Data[ele.SurveySectionDefinitionID];
        // }
        //ONV-6525 fix 
        if (this.aiSurveyData?.Response?.Data) {
 
          const match =
            this.aiSurveyData.Response.Data.find(
              i => Number(i.SectionID) === Number(ele.SurveySectionDefinitionID)
            ) ||
            this.aiSurveyData.Response.Data.find(
              i => Number(i.SurveySectionDefinitionID) === Number(ele.SurveySectionDefinitionID)
            );
          ele.aiSurveyScore = match?.SectionScore ?? 0;
        }
        // if(this.aiSurveyData?.Response?.Data){
        //   ele.aiSurveyScore = this.aiSurveyData.Response.Data.find(i => i.SurveySectionDefinitionID == ele.SurveySectionDefinitionID)?.SectionScore;
        // }
        // ele.FieldGroup.Comments = [];
        ele.FieldGroup.Fields.forEach(element => {
          if(this.aiSurveyData?.Response?.Data){
            element.aiFieldScore = this.getAIFieldScore(element)
            const comments = this.aiSurveyData.Response.Data.find(x => x.FieldID == element.FieldID)?.Comments;
            element.aiComments = comments ?? '';
            element.isAIComments = comments != null && comments.trim() !== '';
          }
          if (this.savedSurveyRes) {
            this.savedSurveyRes.Sections.forEach(savedElement => {
              savedElement.Responses.forEach(savedResponse => {
                if (savedResponse.Values[0] == null || savedResponse.Values[0] == 'SelectOne') {
                  const nullObject = {
                    FieldOptionID: null,
                    Name: 'SelectOne',
                    Value: '-1',
                    DisplayOrder: null,
                    ScoreValue: 0,
                  };
                  // element.FieldOptions.unshift(nullObject)
                  const filteredSelectOption = element.FieldOptions.filter(i => i.Name == 'SelectOne');
                  if (filteredSelectOption && filteredSelectOption.length <= 0) {
                    element.FieldOptions.unshift(nullObject);
                  }
                }
                if (savedResponse.Label == element.Name) {
                  if (savedResponse.Values[0] == null) {
                    savedResponse.Values[0] = 'SelectOne';
                  }
                  const FieldOptions = element.FieldOptions.filter(i => i.Name == savedResponse.Values[0]);
                  element.selectedFieldOption = FieldOptions[0];
                  // console.log(savedResponse);
                  if (savedResponse.Comments.length > 0) {
                    //let lastCommentIndex = savedResponse.Comments.length - 1;
                    let comments = savedResponse.Comments.filter(x=>x.Comment !="");
                    if(comments.length>0){
                      element.Comments = savedResponse.Comments[comments.length - 1].Comment;
                      element.FieldResponseCommentID = savedResponse.Comments[comments.length - 1].FieldResponseCommentID;
                      element.commentValue = 1
                    }
                    else{
                      element.commentValue = 0
                    }
                  } else {
                    element.commentValue = 0;
                  }

                  // element.Comments = 'test 1' Response.Data.Sections[0].Responses[0].Comments[0].Comment
                  // console.log(element.Comments);

                  this.showPoints = true;
                    ele.Points += FieldOptions[0].ScoreValue;
                  ele.Max += element.FieldOptions.reduce((prev, current) =>
                    prev.ScoreValue > current.ScoreValue ? prev : current
                  ).ScoreValue;
                  // ele.groupLabelStatus = 'Complete'
                  ele.zeroPoints = true;
                }
              });
            });

          // ONV-6538 - Existing AI Audit Statistical value
if (ele.Name === 'Statistical' && element.Name === 'Call Type' && (!element.selectedFieldOption || element.selectedFieldOption.Name === 'SelectOne')) 
  {
  const aiStatisticalResponse =
    this.aiSurveyData?.Response?.Data?.find(
      x =>
        x.SectionName === 'Statistical' &&
        x.FieldName === 'Call Type' &&
        Number(x.FieldID) === Number(element.FieldID)
    );
 
  if (aiStatisticalResponse) 
    {
      const aiOption = element.FieldOptions.find(
      option =>
        Number(option.FieldOptionID) ===
        Number(aiStatisticalResponse.FieldOptionID)
    );
 
    if (aiOption) {
      element.selectedFieldOption = aiOption;
             }
           }
          }
        }
          //end
          else {
            if (element.DefaultOption != null) {
              //const FieldOptions = this.isSelectedFieldOption(element);
              const FieldOptions = element.FieldOptions.filter(i => {
                const selectedOptionId = this.aiSurveyData?.Response?.Data?.find(x => x.FieldID === element.FieldID)?.FieldOptionID;
                  return i.FieldOptionID === (selectedOptionId ?? element.DefaultOption?.FieldOptionID);
              });
              element.selectedFieldOption = FieldOptions[0];
              this.showPoints = true;
              ele.Points += FieldOptions[0].ScoreValue;
              element.commentValue = 0;
              ele.Max += element.FieldOptions.reduce((prev, current) =>
                prev.ScoreValue > current.ScoreValue ? prev : current
              ).ScoreValue;

              // console.log(element.selectedFieldOption, 'by default');

              // ele.groupLabelStatus = 'Complete'
              ele.zeroPoints = true;
            } else if (element.DefaultOption == null) {
              this.showPoints = false;

              const nullObject = {
                FieldOptionID: null,
                Name: 'SelectOne',
                Value: '-1',
                DisplayOrder: null,
                ScoreValue: 0,
              };
              // element.FieldOptions.unshift(nullObject)
              const filteredSelectOption = element.FieldOptions.filter(i => i.Name == 'SelectOne');
              if (filteredSelectOption && filteredSelectOption.length <= 0) {
                element.FieldOptions.unshift(nullObject);
              }
              element.FieldOptions[0].ScoreValue = 0;
              element.commentValue = 0;
              //element.selectedFieldOption = element.FieldOptions[0];
              //ONV-6538-Statistical Section- By default -Provider
    const aiStatisticalResponse = this.aiSurveyData?.Response?.Data?.find(
    x =>
    x.SectionName === 'Statistical' &&
    x.FieldName === 'Call Type' &&
    Number(x.FieldID) === Number(element.FieldID));
  if (aiStatisticalResponse) 
  {
   const aiOption = element.FieldOptions.find(option => Number(option.FieldOptionID) === Number(aiStatisticalResponse.FieldOptionID) );
 
  element.selectedFieldOption = aiOption ?? element.FieldOptions[0];
  } 
  else 
  {
  element.selectedFieldOption = element.FieldOptions[0];
  }
              if (this.savedSurveyRes) {
                this.savedSurveyRes.Sections.forEach(savedElement => {
                  savedElement.Responses.forEach(savedResponse => {
                    if (savedResponse.Label == element.Name) {
                      if (savedResponse.Values[0] == null) {
                        savedResponse.Values[0] = 'SelectOne';
                      }
                      const FieldOptions = element.FieldOptions.filter(i => i.Name == savedResponse.Values[0]);
                      element.selectedFieldOption = FieldOptions[0];
                      this.showPoints = true;
                      // ele.Points += FieldOptions[0].ScoreValue;
                      // ele.Max +=  FieldOptions.reduce((prev, current) => (prev.ScoreValue > current.ScoreValue) ? prev : current).ScoreValue;
                      // ele.groupLabelStatus = 'Complete'
                      // ele.zeroPoints = true
                    }
                  });
                });
              }

              if (element.selectedFieldOption.Name == 'SelectOne') {
                ele.groupLabelStatus = 'In Progress';
              } else {
                ele.groupLabelStatus = 'Complete';
              }
            }
          }
          if (!element.showComments) {
            element.showComments = false;
          }
          if (element.selectedFieldOption.Name == 'SelectOne') {
            ele.groupLabelStatus = 'In Progress';
          } else {
            ele.groupLabelStatus = 'Complete';
          }
          const name = element.ShortName;
          const value = element.selectedFieldOption.Value;
          // console.log(name, value, 'datavalue');
          ele.FieldGroup.Data[name] = value;

          //set for API
          // element.Changes={}
          // console.log(element);
        });
        if (ele.Points == 0 && ele.Max == 0) {
          ele.showPoints = false;
        } else {
          ele.showPoints = true;
        }

        this.checkStatusArray.push(ele.groupLabelStatus);
        ele.Score = this.getPercentage(ele.Points, ele.Max);
        ele.Score = isNaN(ele.Score) ? 0 : ele.Score;
        sectionTotal += ele.Points;
        const isBonusByName = ele.Name?.toLowerCase() === 'bonus' || ele.FieldGroup?.Name?.toLowerCase() === 'bonus';
        const scorePercentage = ele.ScorePercentage ?? 100;
        const isExcludedByWeight = scorePercentage === 0 || isBonusByName;
        if (!isExcludedByWeight) {
          totalSectionPoints += ele.Max;
        }
      });
      this.surveySections.sectionTotal = sectionTotal < 0 ? 0 : sectionTotal;
      this.surveySections.totalSectionPoints = totalSectionPoints;
      this.surveySections.totalSectionScore = this.getPercentage(
        this.surveySections.sectionTotal,
        this.surveySections.totalSectionPoints
      );
      //call submitsurvey API

      this.saveSectionData = this.surveySections.map(savedSurveyDetails => {
        const {
          Points,
          Max,
          Score,
          FieldGroup: { Data, Changes, FieldGroupID },
        } = savedSurveyDetails;

        return { Points, Max, Score, Data, Changes, FieldGroupID };
      });

      if (this.surveyID == null) {
        this.saveSurvey(null, false, null);
        this.status = true;
      }
      //  console.log(this.surveyPermissions, 'perm');

      if (this.checkStatusArray.includes('In Progress')) {
        if (this.surveyPermissions.Status.Name == 'Pending') this.surveySections.sectionLabelStatus = 'In Progress';
        this.showSubmitBtn = false;
      } else {
        // this.showSubmitBtn = true;
        this.surveyPermissions.Actions.forEach(element => {
          if (element.Name == 'Submit') {
            this.submitLabel = element.Label;
            //this.surveyActionID = element.SurveyActionID;
            this.showSubmitBtn = true;
          }
        });
        const allComplete = Object.values(this.checkStatusArray).every( status => status === "Complete" );
        this.surveySections.sectionLabelStatus = allComplete == true ? "Complete" : "In Progress";
        if (this.surveySections.sectionLabelStatus == 'Submitted') {
          this.showSubmitBtn = false;
        }
      }
      // console.log(this.surveySections,'check sections');

      // if (this.surveySections.sectionLabelStatus == 'Complete') {

      // }

      this.showExportBtn = false;
      this.showDeleteBtn = false;
      this.surveyPermissions.Actions.forEach(element => {
        if (element.Name == 'SaveDraft') {
          this.saveLabel = element.Label;
          //this.surveyActionID = element.SurveyActionID;
          this.showSaveDraftBtn = true;
          // this.showSubmitBtn = false
        }
        if (element.Name == 'Delete') {
          this.deleteLabel = element.Label;
          //this.surveyActionID = element.SurveyActionID;
          this.showDeleteBtn = true;
        }
        if (element.Name == 'Export') {
          this.exportLabel = element.Label;
          //this.surveyActionID = element.SurveyActionID;
          this.showExportBtn = true;
        }
      });

      // if(this.surveyPermissions.Status.Name == '')
    }
  }
  // async createNewAuditSurvey(surveyStatus: boolean) {
  //   const uc1 = { interactionID: this.interactionId, isAISurveyScore: false,isAIData: true, surveyDefinitionID: this.selectedForm.SurveyDefinitionID };
  //   this.aiSurveyData = await lastValueFrom(this.auditorService.GetSurvey(null,uc1));
  //   if (surveyStatus && this.selectedType && this.selectedSurvey?.Status?.Name != 'Deleted' && this.selectedSurvey?.SurveyID==null) {
  //     this.savedSurveyId = undefined;
  //     this.savedSurveyRes = null;
  //     this.newSurveyData = null;
  //     this.surveySections = [];
  //     this.surveyPermissions = null;
  //     this.surveyID = null;
  //     this.showSurveyDetails = false;

  //     this.surveyTypeID = this.selectedType.ID;
  //     this.surveyDefinitionID = this.selectedType.SurveyDefinitionID;

  //     const surveyDefinitionRes: any = await lastValueFrom(
  //       this.auditorService.GetSurveyDefinition(this.surveyDefinitionID)
  //     );

  //     this.newSurveyData = surveyDefinitionRes.Response.Data;
  //     this.surveySections = JSON.parse(JSON.stringify(this.newSurveyData.Sections));
  //     this.showSurveyDetails = true;
  //   }

  //   //Filter out deleted surveys before checking for duplicates
  //   // this.selectedSurveyArray = this.selectedSurveyArray?.filter(survey => survey.Status?.Name !== 'Deleted');

  //   this.existingSurvey = this.checkingSurveyWithDefinitionAndType(this.selectedForm, this.selectedType);
  //   console.log('existingSurvey', this.existingSurvey);
  //   if (
  //     surveyStatus == true &&
  //     this.selectedSurveyArray &&
  //     this.selectedSurveyArray.length > 0 &&
  //     //this.selectedSurvey?.Status?.Name !== 'Deleted' &&
  //     this.existingSurvey
  //   ) {
  //     const initialState = {
  //       title: 'Duplicate Survey',
  //       contentMsg:
  //         'You already have a survey that uses this form. \n \n' +
  //         this.selectedSurvey.SurveyID +
  //         ':' +
  //         this.selectedForm.Name +
  //         '-' +
  //         this.selectedType?.Name +
  //         '(' +
  //         this.selectedSurvey.Status.Name +
  //         ')' +
  //         '\n \n' +
  //         '\n \n Would you like to open it?',
  //       confirmBtnValue: 'Ok',
  //       cancelBtnValue: 'Cancel',
  //       isConfirm: true,
  //       isDelete: false,
  //     };

  //     const config: ModalOptions = {
  //       class: 'confirm-dialog modal-wd-290',
  //       initialState,
  //     };

  //     this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
  //     this.modalRef.content.event.subscribe((result: any) => {
  //       if (result.value == 'confirm') {
  //         this.selectedSurvey = this.existingSurvey;
  //         this.openAuditSurvey();
  //       }
  //       this.modalRef.hide();
  //     });
  //   } else {
  //     this.showSurveyDetails = true;

  //     let user = this.webStorageService.getItemFromSessionStorage('currentUser');
  //     this.newName = 'New';
  //     this.userDetails = user;

  //     console.log(this.savedSurveyId, 'savedSurvey');
  //     // console.log(this.openAuditResponse, 'vall');
  //     if (this.savedSurveyId != undefined && !this.duplicateSavedSurveyId) {
  //       this.newName = '';

  //       const surveyRes: any = await lastValueFrom(this.auditorService.GetSurvey(this.savedSurveyId,null));
  //       // console.log(surveyRes, 'surveyRes');

  //       this.savedSurveyRes = surveyRes.Response.Data;
  //       this.userDetails = this.savedSurveyRes.User;
  //       if (user?.UserID == this.userDetails?.UserID) {
  //         this.isSameAgent = Number(user.UserID) === Number(this.userDetails?.UserID);
  //       }
  //       if (this.isSameAgent) {
  //         this.showSaveDraftBtn = true;
  //         this.saveLabel = 'Save Changes';
  //       } else {
  //         this.showSaveDraftBtn = false;
  //         this.saveLabel = ''; 
  //       }
  //       const surveyPermissionsRes: any = await lastValueFrom(
  //         this.auditorService.GetSurveyPermissions(this.savedSurveyId)
  //       );
  //       this.surveyPermissions = surveyPermissionsRes.Response.Data;
  //       if (this.openAuditResponse == true) {
  //         const surveyDefinitionRes: any = await lastValueFrom(
  //           this.auditorService.GetSurveyDefinition(this.selectedForm.SurveyDefinitionID)
  //         );
  //         this.newSurveyData = surveyDefinitionRes.Response.Data;
  //         this.surveySections = surveyDefinitionRes.Response.Data.Sections;
  //         this.openAuditResponse = false;
  //       }
  //     } else {
  //       const surveyDefinitionRes: any = await lastValueFrom(
  //         this.auditorService.GetSurveyDefinition(this.selectedForm.SurveyDefinitionID)
  //       );
  //       this.newSurveyData = surveyDefinitionRes.Response.Data;
  //       this.surveySections = surveyDefinitionRes.Response.Data.Sections;

  //       const surveyPermissionsRes: any = await lastValueFrom(this.auditorService.GetSurveyPermissions(null));
  //       this.surveyPermissions = surveyPermissionsRes.Response.Data;
  //     }

  //     // console.log(this.surveyPermissions);

  //     // console.log(this.savedSurveyRes, 'getsurvey');
  //     //  console.log(surveyRes);

  //     // if(this.surveyPermissions.SurveyID != null){
  //     this.surveyID = this.surveyPermissions.SurveyID;
  //     if (this.surveyID == 0) {
  //       this.surveyActionID = this.surveyPermissions.Actions[0]?.SurveyActionID;
  //       this.surveyID = null;
  //     }
  //     // }

  //     this.surveyTypeID = this.selectedType.ID;
  //     this.surveyDefinitionID = this.selectedForm.SurveyDefinitionID;

  //     this.isSubmitted = true;
  //     let sectionTotal = 0;
  //     let totalSectionPoints = 0;
  //     this.surveySections.forEach(ele => {
  //       ele.Points = 0;
  //       ele.Max = 0;
  //       ele.FieldGroup.Changes = {};
  //       ele.FieldGroup.Data = {};
  //       ele.surveyID = null;
  //       ele.commentID = 0;
  //       ele.aiSurveyScore = 0;
  //       // console.log(`Section: ${ele.Name}, Max: ${ele.Max}, Points: ${ele.Points}`);
  //       // if(this.aiSurveyRes?.Response?.Data){
  //       //   ele.aiSurveyScore = this.aiSurveyRes.Response.Data[ele.SurveySectionDefinitionID];
  //       // }
  //       if(this.aiSurveyData?.Response?.Data){
  //         ele.aiSurveyScore = this.aiSurveyData.Response.Data.find(i => i.SurveySectionDefinitionID == ele.SurveySectionDefinitionID)?.SectionScore;
  //       }
  //       // ele.FieldGroup.Comments = [];
  //       ele.FieldGroup.Fields.forEach(element => {
  //         if(this.aiSurveyData?.Response?.Data){
  //           element.aiFieldScore = this.getAIFieldScore(element)
  //           const comments = this.aiSurveyData.Response.Data.find(x => x.FieldID == element.FieldID)?.Comments;
  //           element.aiComments = comments ?? '';
  //           element.isAIComments = comments != null && comments.trim() !== '';
  //         }
  //         if (this.savedSurveyRes) {
  //           this.savedSurveyRes.Sections.forEach(savedElement => {
  //             savedElement.Responses.forEach(savedResponse => {
  //               if (savedResponse.Values[0] == null || savedResponse.Values[0] == 'SelectOne') {
  //                 const nullObject = {
  //                   FieldOptionID: null,
  //                   Name: 'SelectOne',
  //                   Value: '-1',
  //                   DisplayOrder: null,
  //                   ScoreValue: 0,
  //                 };
  //                 // element.FieldOptions.unshift(nullObject)
  //                 const filteredSelectOption = element.FieldOptions.filter(i => i.Name == 'SelectOne');
  //                 if (filteredSelectOption && filteredSelectOption.length <= 0) {
  //                   element.FieldOptions.unshift(nullObject);
  //                 }
  //               }
  //               if (savedResponse.Label == element.Name) {
  //                 if (savedResponse.Values[0] == null) {
  //                   savedResponse.Values[0] = 'SelectOne';
  //                 }
  //                 const FieldOptions = element.FieldOptions.filter(i => i.Name == savedResponse.Values[0]);
  //                 element.selectedFieldOption = FieldOptions[0];
  //                 // console.log(savedResponse);
  //                 if (savedResponse.Comments.length > 0) {
  //                   //let lastCommentIndex = savedResponse.Comments.length - 1;
  //                   let comments = savedResponse.Comments.filter(x=>x.Comment !="");
  //                   if(comments.length>0){
  //                     element.Comments = savedResponse.Comments[comments.length - 1].Comment;
  //                     element.FieldResponseCommentID = savedResponse.Comments[comments.length - 1].FieldResponseCommentID;
  //                     element.commentValue = 1
  //                   }
  //                   else{
  //                     element.commentValue = 0
  //                   }
  //                 } else {
  //                   element.commentValue = 0;
  //                 }

  //                 // element.Comments = 'test 1' Response.Data.Sections[0].Responses[0].Comments[0].Comment
  //                 // console.log(element.Comments);

  //                 this.showPoints = true;
  //                 ele.Points += FieldOptions[0].ScoreValue;
  //                 ele.Max += element.FieldOptions.reduce((prev, current) =>
  //                   prev.ScoreValue > current.ScoreValue ? prev : current
  //                 ).ScoreValue;
  //                 // ele.groupLabelStatus = 'Complete'
  //                 ele.zeroPoints = true;
  //               }
  //             });
  //           });
  //         } else {
  //           if (element.DefaultOption != null) {
  //             const FieldOptions = element.FieldOptions.filter(
  //               i => i.FieldOptionID == element.DefaultOption.FieldOptionID
  //             );
  //             element.selectedFieldOption = FieldOptions[0];
  //             this.showPoints = true;
  //             ele.Points += FieldOptions[0].ScoreValue;
  //             element.commentValue = 0;
  //             ele.Max += element.FieldOptions.reduce((prev, current) =>
  //               prev.ScoreValue > current.ScoreValue ? prev : current
  //             ).ScoreValue;

  //             // console.log(element.selectedFieldOption, 'by default');

  //             // ele.groupLabelStatus = 'Complete'
  //             ele.zeroPoints = true;
  //           } else if (element.DefaultOption == null) {
  //             this.showPoints = false;

  //             const nullObject = {
  //               FieldOptionID: null,
  //               Name: 'SelectOne',
  //               Value: '-1',
  //               DisplayOrder: null,
  //               ScoreValue: 0,
  //             };
  //             // element.FieldOptions.unshift(nullObject)
  //             const filteredSelectOption = element.FieldOptions.filter(i => i.Name == 'SelectOne');
  //             if (filteredSelectOption && filteredSelectOption.length <= 0) {
  //               element.FieldOptions.unshift(nullObject);
  //             }
  //             element.FieldOptions[0].ScoreValue = 0;
  //             element.commentValue = 0;
  //             element.selectedFieldOption = element.FieldOptions[0];
  //             if (this.savedSurveyRes) {
  //               this.savedSurveyRes.Sections.forEach(savedElement => {
  //                 savedElement.Responses.forEach(savedResponse => {
  //                   if (savedResponse.Label == element.Name) {
  //                     if (savedResponse.Values[0] == null) {
  //                       savedResponse.Values[0] = 'SelectOne';
  //                     }
  //                     const FieldOptions = element.FieldOptions.filter(i => i.Name == savedResponse.Values[0]);
  //                     element.selectedFieldOption = FieldOptions[0];
  //                     this.showPoints = true;
  //                     // ele.Points += FieldOptions[0].ScoreValue;
  //                     // ele.Max +=  FieldOptions.reduce((prev, current) => (prev.ScoreValue > current.ScoreValue) ? prev : current).ScoreValue;
  //                     // ele.groupLabelStatus = 'Complete'
  //                     // ele.zeroPoints = true
  //                   }
  //                 });
  //               });
  //             }

  //             if (element.selectedFieldOption.Name == 'SelectOne') {
  //               ele.groupLabelStatus = 'In Progress';
  //             } else {
  //               ele.groupLabelStatus = 'Complete';
  //             }
  //           }
  //         }
  //         if (!element.showComments) {
  //           element.showComments = false;
  //         }
  //         if (element.selectedFieldOption.Name == 'SelectOne') {
  //           ele.groupLabelStatus = 'In Progress';
  //         } else {
  //           ele.groupLabelStatus = 'Complete';
  //         }
  //         const name = element.ShortName;
  //         const value = element.selectedFieldOption.Value;
  //         // console.log(name, value, 'datavalue');
  //         ele.FieldGroup.Data[name] = value;

  //         //set for API
  //         // element.Changes={}
  //         // console.log(element);
  //       });
  //       if (ele.Points == 0 && ele.Max == 0) {
  //         ele.showPoints = false;
  //       } else {
  //         ele.showPoints = true;
  //       }

  //       this.checkStatusArray.push(ele.groupLabelStatus);
  //       ele.Score = this.getPercentage(ele.Points, ele.Max);
  //       ele.Score = isNaN(ele.Score) ? 0 : ele.Score;
  //       sectionTotal += ele.Points;
  //       const isBonusByName = ele.Name?.toLowerCase() === 'bonus' || ele.FieldGroup?.Name?.toLowerCase() === 'bonus';
  //       const scorePercentage = ele.ScorePercentage ?? 100;
  //       const isExcludedByWeight = scorePercentage === 0 || isBonusByName;
  //       if (!isExcludedByWeight) {
  //         totalSectionPoints += ele.Max;
  //       }
  //     });
  //     this.surveySections.sectionTotal = sectionTotal;
  //     this.surveySections.totalSectionPoints = totalSectionPoints;
  //     this.surveySections.totalSectionScore = this.getPercentage(
  //       this.surveySections.sectionTotal,
  //       this.surveySections.totalSectionPoints
  //     );
  //     //call submitsurvey API

  //     this.saveSectionData = this.surveySections.map(savedSurveyDetails => {
  //       const {
  //         Points,
  //         Max,
  //         Score,
  //         FieldGroup: { Data, Changes, FieldGroupID },
  //       } = savedSurveyDetails;

  //       return { Points, Max, Score, Data, Changes, FieldGroupID };
  //     });

  //     if (this.surveyID == null) {
  //       this.saveSurvey(null, false, null);
  //       this.status = true;
  //     }
  //     //  console.log(this.surveyPermissions, 'perm');

  //     if (this.checkStatusArray.includes('In Progress')) {
  //       if (this.surveyPermissions.Status.Name == 'Pending') this.surveySections.sectionLabelStatus = 'In Progress';
  //       this.showSubmitBtn = false;
  //     } else {
  //       // this.showSubmitBtn = true;
  //       this.surveyPermissions.Actions.forEach(element => {
  //         if (element.Name == 'Submit') {
  //           this.submitLabel = element.Label;
  //           //this.surveyActionID = element.SurveyActionID;
  //           this.showSubmitBtn = true;
  //         }
  //       });
  //       const allComplete = Object.values(this.checkStatusArray).every( status => status === "Complete" );
  //       this.surveySections.sectionLabelStatus = allComplete == true ? "Complete" : "In Progress";
  //       if (this.surveySections.sectionLabelStatus == 'Submitted') {
  //         this.showSubmitBtn = false;
  //       }
  //     }
  //     // console.log(this.surveySections,'check sections');

  //     // if (this.surveySections.sectionLabelStatus == 'Complete') {

  //     // }

  //     this.showExportBtn = false;
  //     this.showDeleteBtn = false;
  //     this.surveyPermissions.Actions.forEach(element => {
  //       if (element.Name == 'SaveDraft') {
  //         this.saveLabel = element.Label;
  //         //this.surveyActionID = element.SurveyActionID;
  //         this.showSaveDraftBtn = true;
  //         // this.showSubmitBtn = false
  //       }
  //       if (element.Name == 'Delete') {
  //         this.deleteLabel = element.Label;
  //         //this.surveyActionID = element.SurveyActionID;
  //         this.showDeleteBtn = true;
  //       }
  //       if (element.Name == 'Export') {
  //         this.exportLabel = element.Label;
  //         //this.surveyActionID = element.SurveyActionID;
  //         this.showExportBtn = true;
  //       }
  //     });

  //     // if(this.surveyPermissions.Status.Name == '')
  //   }
  // }

//  getYesScore(field: any): number | null {
//   return field?.FieldOptions?.find(x => x.Name === 'Yes')?.ScoreValue ?? null;
// }

getAIFieldScore(field: any): number | null {
  const item = this.aiSurveyData?.Response?.Data
    ?.find(x =>x.FieldID == field.FieldID);

  if (!item) {
    return null;
  }

  const score = item.FieldScore ?? 0;

  switch (item.OptionSelected) {
    case 'No':
      return -Math.abs(score);

    case 'N/A':
      return field?.FieldOptions?.find(x => x.Name === item.OptionSelected)?.ScoreValue;

    case 'Yes':
    default:
      return item?.FieldName == 'HIPAA Violation' && item?.SectionName == 'Disqualifying Event' ? -Math.abs(score) : Math.abs(score);
  }
}
  changeFieldOption(event, fieldObject, i, selectedFormFieldOption) {
    this.updateScoreValue(selectedFormFieldOption);
  }

  updateScoreValue(selectedFormFieldOption) {
    let sectionTotal = 0;
    this.checkStatusArray = [];
    this.surveySections.forEach(ele => {
      ele.Points = 0;

      ele.FieldGroup.Fields.forEach(element => {
        // console.log(element.selectedFieldOption);

        if (element.selectedFieldOption.Name == 'SelectOne') {
          ele.groupLabelStatus = 'In Progress';
        } else {
          ele.groupLabelStatus = 'Complete';
        }
        ele.Points += element.selectedFieldOption.ScoreValue;
        // console.log(element.selectedFieldOption,'updated field options');

        ele.Score = this.getPercentage(ele.Points, ele.Max);
        // console.log(ele.Score, 'per');
        // if(ele.Score == NaN){
        //   console.log("HI");
        //   ele.Score = 0

        // }
        ele.Score = isNaN(ele.Score) ? 0 : ele.Score;
        // console.log(ele.Score, 'perup');

        // this.updatedSectionsArray.push(element.selectedFieldOption);
        // console.log(this.updatedSectionsArray,'updated sections list');
        // if(!ele.Changes){
        // }
        if (element.selectedFieldOption) {
          // console.log(ele);
          const name = element.ShortName;
          const value = element.selectedFieldOption.Name;

          // ele.Changes={name,value};
          //  console.log(element, 'element');
          // console.log(element.DefaultOption,'default')
          // if (element.DefaultOption) {
          //   if (element.DefaultOption.FieldOptionID != element.selectedFieldOption.FieldOptionID) {
          //     ele.FieldGroup.Changes[name] = value;
          //     // const { Changes,Points,sectionTotal,percentage} = ele
          //     // const extractedFields = {Changes,Points,sectionTotal,percentage}
          //     // console.log(extractedFields,'extracted');
          //   }
          // } else if (element.selectedFieldOption.Name != 'SelectOne') {
          //     ele.FieldGroup.Changes[name] = value;
          // }

          if (element.selectedFieldOption) {
            if (ele.FieldGroup.Changes.hasOwnProperty(name)) {
              if (ele.FieldGroup.Changes[name] != value) {
                ele.FieldGroup.Changes[name] = value;
              }
            } else if (element.selectedFieldOption.Name != 'SelectOne' && selectedFormFieldOption.FieldOptionID == element.selectedFieldOption.FieldOptionID) {
              ele.FieldGroup.Changes[name] = value;
            }
          }

          // console.log(element.selectedFieldOption,'selectedfieldoption')
          // console.log(element.Name,'seleceted Name');
        }
      });
      sectionTotal += ele.Points;
      this.checkStatusArray.push(ele.groupLabelStatus);
    });

    this.surveySections.sectionTotal = sectionTotal;
    this.surveySections.totalSectionScore = this.getPercentage(
      this.surveySections.sectionTotal,
      this.surveySections.totalSectionPoints
    );
    // console.log(this.surveySections, 'final data');
    // console.log(this.surveySections.totalSectionScore, 'per');

    this.saveSectionData = this.surveySections.map(savedSurveyDetails => {
      const {
        Points,
        Max,
        Score,
        FieldGroup: { Changes, FieldGroupID },
      } = savedSurveyDetails;

      return { Points, Max, Score, Changes, FieldGroupID };
    });

    // console.log(this.saveSectionData, 'savedSection');

    if (this.checkStatusArray.includes('In Progress')) {
      if (this.surveyPermissions.Status.Name == 'Pending') {
        this.surveySections.sectionLabelStatus = 'In Progress';
        this.showSubmitBtn = false;
      }
    } else {
      //  this.surveySections.sectionLabelStatus = this.surveyPermissions.Status.Name;
      this.surveyPermissions.Actions.forEach(element => {
        if (element.Name == 'Submit') {
          this.submitLabel = element.Label;
          //this.surveyActionID = element.SurveyActionID;
          this.showSubmitBtn = true;
        }
        const allComplete = Object.values(this.checkStatusArray).every( status => status === "Complete" );
        this.surveySections.sectionLabelStatus = allComplete == true ? "Complete" : "In Progress";
        if (this.surveySections.sectionLabelStatus == 'Submitted') {
          this.showSubmitBtn = false;
        }
      });
    }
  }
  getPercentage(partialValue, totalValue) {
    // let percentage = (100 * partialValue) / totalValue;
    //   if(percentage.includes('.')){

    //   }
    return (100 * partialValue) / totalValue;
  }

  // async showCommentBox(index1, index2) {
  //   const showCommentState = this.surveySections[index1].FieldGroup.Fields[index2].showComments;
  //   this.surveySections[index1].FieldGroup.Fields[index2].showComments = showCommentState ? false : true;
  // }
  showCommentBox(index1: number, index2: number): void {

    const field =
      this.surveySections[index1].FieldGroup.Fields[index2];
  
    field.showComments = !field.showComments;
  
    const hasAIComments =
      field.aiComments &&
      field.aiComments.trim() !== '';
  
    field.showAIComments =
      field.showComments && hasAIComments;
  }
   updateComments(event: any, index1, index2) {
    const newComment = event.target.value;
    let oldComment = this.surveySections[index1].FieldGroup.Fields[index2].Comments;
    if (newComment && oldComment !== newComment && !oldComment.includes(newComment)) {
      oldComment = oldComment ? `${oldComment} ${newComment}` : newComment;
    }
    this.surveySections[index1].FieldGroup.Fields[index2].Comments = oldComment;
  };
  async onSave(event: any, index1, index2,field) {
      let content = this.surveySections[index1].FieldGroup.Fields[index2].Comments;
      if(!content){
        content = '';
      }

      const fieldGroupID = this.surveySections[index1].FieldGroup.FieldGroupID;

      const fieldName = this.surveySections[index1].FieldGroup.Fields[index2].ShortName;

      const commentID = this.surveySections[index1].FieldGroup.Fields[index2].FieldResponseCommentID
        ? this.surveySections[index1].FieldGroup.Fields[index2].FieldResponseCommentID
        : null;
      //console.log(commentID);
      this.checkCommentsLength = content?.length;

      if (this.checkCommentsLength) {
        this.surveySections[index1].FieldGroup.Fields[index2].commentValue = 1;
      } else {
        this.surveySections[index1].FieldGroup.Fields[index2].commentValue = 0;
      }

      const data = {
        surveyID: this.savedSurveyId,
        commentID: commentID,
        fieldGroupID: fieldGroupID,
        fieldName: fieldName,
        content: content,
      };

      const surveyCommentSaveRes: any = await lastValueFrom(this.auditorService.EditSurveyComments(data));
      field.showComments = false;
      field.showAIComments = false;
      field.showMandatoryError = false;
  }

  async saveSurvey(event, delOpt: boolean, action: any) {
    if (this.aiScoreSubmitted && action === 'Save Changes' && !this.validateMandatoryComments()) 
      {
       return;
      }
 
    // console.log(delOpt, 'del');

    // console.log(event);
    // console.log(this.surveyPermissions);
    if (action != null) {
      this.surveyPermissions.Actions.forEach(element => {
        if (element.Label == action) {
          this.surveyActionID = element.SurveyActionID;
        }
      });
    }
    if (this.savedSurveyId && !this.duplicateSavedSurveyId) {
      this.surveyID = this.savedSurveyId;
    } else {
      this.surveyID = null;
    }
    const data = {
      surveyID: this.surveyID,
      surveyActionID: this.surveyActionID,
      surveyTypeID: this.surveyTypeID,
      surveyDefinitionID: this.surveyDefinitionID,
      interactionID: this.interactionId,
      survey: {
        Sections: this.saveSectionData,
        Total: Number(this.surveySections.totalSectionScore),
        TotalPoints: this.surveySections.sectionTotal,
        TotalMax: this.surveySections.totalSectionPoints,
      },

      overwrite: false,
      scorecheck: false,
    };

    if (delOpt == true) {
      const initialState = {
        title: 'Deleting Audit',
        contentMsg: 'Are you sure you want to delete this audit?',
        cancelBtnValue: 'Cancel',
        deleteBtnValue: 'Delete',
        isConfirm: false,
        isDelete: true,
      };

      const config: ModalOptions = {
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };
      this.saveSurveyTimeout = setTimeout(() => {
        this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
        this.modalRef.content.event.subscribe(async (result: any) => {
          if (result.value == 'delete') {
            const surveySaveRes: any = await lastValueFrom(this.auditorService.saveSubmitSurvey(data));
  
            const surveyDefinitionsRes: any = await lastValueFrom(
              this.auditorService.GetSurveyDefinitions(data.interactionID)
            );
            let surveyDefinitions = surveyDefinitionsRes.Response.Data.filter(item=>item.SurveyDefinitionID == data.surveyDefinitionID);
            //this.emptySurveys = surveyDefinitionsRes.Response.Data.Surveys;
            this.emptySurveys = surveyDefinitions[0].Surveys;
            this.selectedTypeArray = surveyDefinitions[0].Types;
            console.log('Raw surveys from API:', this.emptySurveys);
            this.selectedSurveyArray = this.emptySurveys;
            this.selectedSurvey = this.selectedSurveyArray[0];
            //this.selectedSurveyArray = this.emptySurveys.filter(survey => survey.Status?.Name !== 'Deleted');
            if (this.selectedSurveyArray && this.selectedSurveyArray.length <= 0) {
              this.showOpenSurvey = false;
            }
            this.emptySections = surveyDefinitionsRes.Response.Data[0].Sections;
            if (this.emptySections && this.emptySections.length <= 0) {
              this.surveySections = [];
              this.isSubmitted = false;
            }
  
            console.log(surveySaveRes, 'saved after del');
            if (surveySaveRes.Response.Data != null) {
              this.savedSurveyId = surveySaveRes.Response.Data;
              //this.savedSurveyId = null;
            }
            if (typeof surveySaveRes.Response.Data === 'object') {
              this.savedSurveyId = surveySaveRes.Response.Data.ID;
              //this.savedSurveyId = null;
            }
  
            this.savedSurveyRes = null;
            this.surveyID = null;
  
            //this.isDeleted = true;
            // console.log(this.savedSurveyRes, 'del');
          }
          this.updateAIReviewAIScore();
          this.modalRef.hide();
        });
        if (this.modalRef) {
          document.body.classList.add('modal-open');
        }
        this.cd.detectChanges();
      }, 0);
    } else {
      // if (this.isDeleted == true) {
      //   data.overwrite = true;
      // }
      const surveySaveRes: any = await lastValueFrom(this.auditorService.saveSubmitSurvey(data));
      // console.log(surveySaveRes);
      const dataFromAPI = surveySaveRes?.Response?.Data;
      
      if (typeof dataFromAPI === 'object' && dataFromAPI?.ID) {
        this.savedSurveyId = dataFromAPI;
        this.surveyID = dataFromAPI.ID;
      } else if (typeof dataFromAPI === 'number') {
        this.savedSurveyId = dataFromAPI;
        this.surveyID = dataFromAPI;
        if(action == 'Submit Audit'){
          this.showSubmitBtn = false;
        }
      } else {
        this.savedSurveyId = null;
        this.surveyID = null;
        //console.warn('No valid survey ID returned from backend');
      }
      if (surveySaveRes.Response.Data != null) {
        this.savedSurveyId = surveySaveRes.Response.Data;
        //this.duplicateSurveyId = surveySaveRes.Response.Data;
      }
      if (typeof surveySaveRes.Response.Data === 'object' && surveySaveRes.Response.Data.ID != null) {
        this.savedSurveyId = surveySaveRes.Response.Data.ID;
        this.duplicateSavedSurveyId = surveySaveRes.Response.Data.Deleted;
      }

      // let surveyRes: any = await lastValueFrom(this.auditorService.GetSurvey(this.savedSurveyId));
      // if (action === 'Save Changes' || action === 'Submit Audit') {
      //   console.log('Triggering auditChanged for interaction:', data.interactionID);
      // this.appService.notifyAuditChange(data.interactionID);
      // }

      if (event) {
        this.createNewAuditSurvey(false);
        this.auditSaved = true;
        this.getAuditDetailsByInteractionId(this.interactionId);
        //if (this.selectedSurvey) {
        // this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
        //}
        // this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
      }

      // Reset checkCommentsLength after successful save to prevent false "unsaved changes" warning
      this.checkCommentsLength = 0;
      this.updateAIReviewAIScore();
      // let user = this.webStorageService.getItemFromSessionStorage('currentUser');
      // let company = this.webStorageService.getItemFromSessionStorage('company');
      // const uc = { interactionID: this.interactionId, company: company, user: user, source: this.source };
      // const res: any = await lastValueFrom(this.auditorService.GetInteractionsDetailById(uc));
      // if (res?.Response?.Data) {
      //   this.interactionDetailedData.AIReview = res.Response.Data.AIReview;
      //   this.interactionDetailedData.AIScore = res.Response.Data.AIScore;
      // }
    }
  }
  async updateAIReviewAIScore(){
    let user = this.webStorageService.getItemFromSessionStorage('currentUser');
    let company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { interactionID: this.interactionId, company: company, user: user, source: this.source };
    const res: any = await lastValueFrom(this.auditorService.GetInteractionsDetailById(uc));
    if (res?.Response?.Data) {
      this.interactionDetailedData.AIReview = res.Response.Data.AIReview;
      this.interactionDetailedData.AIScore = res.Response.Data.AIScore;
    }
  }
  // async openAuditSurvey() {
  //   console.log(this.surveyID);
  //   this.newName = '';
  //   this.showSurveyDetails = true;

  //   this.openAuditResponse = true;
  //   this.savedSurveyId = this.selectedSurvey.SurveyID;
  //   this.isChecked = false;

  //   await this.createNewAuditSurvey(false);
  //   let user = this.webStorageService.getItemFromSessionStorage('currentUser');
  //   this.userEmail = user.Email;
  //   this.surveyUserEmail = this.savedSurveyRes.User.Email;
  //   console.log(this.userEmail == this.surveyUserEmail);

  //   this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
  // }
  // async openAuditSurvey() {
  //   if (this.selectedSurvey && this.selectedSurvey.SurveyID) {
  //     this.savedSurveyId = this.selectedSurvey.SurveyID;
  //     this.openAuditResponse = true;
  //     await this.createNewAuditSurvey(false);
  //   } else if (this.selectedType && this.selectedSurveyArray?.length) {
  //     const matchingSurveys = this.selectedSurveyArray.filter(survey => survey.Type?.Name === this.selectedType.Name);

  //     if (matchingSurveys.length > 0) {
  //       const firstMatch = matchingSurveys[0];
  //       this.savedSurveyId = firstMatch.SurveyID;
  //       this.openAuditResponse = true;
  //       await this.createNewAuditSurvey(false);
  //     } else {
  //       this.savedSurveyId = undefined;
  //       this.openAuditResponse = false;
  //       await this.createNewAuditSurvey(true);
  //     }
  //   } else {
  //     //alert('Please select a survey or a type to open.');
  //     return;
  //   }
  //   console.log(this.surveyID);
  //   this.newName = '';
  //   this.showSurveyDetails = true;

  //   this.openAuditResponse = true;
  //   this.savedSurveyId = this.selectedSurvey.SurveyID;
  //   this.isChecked = false;

  //   await this.createNewAuditSurvey(false);
  //   let user = this.webStorageService.getItemFromSessionStorage('currentUser');
  //   this.userEmail = user.Email;
  //   this.surveyUserEmail = this.savedSurveyRes.User.Email;
  //   console.log(this.userEmail == this.surveyUserEmail);

  //   if (this.selectedSurvey?.Status?.Name) {
  //     this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
  //   }
  //   if (this.selectedSurvey && this.selectedSurvey.SurveyID) {
  //     this.savedSurveyId = this.selectedSurvey.SurveyID;
  //     this.openAuditResponse = true;
  //     if (this.selectedSurvey.Type) {
  //       this.selectedType = this.selectedSurvey.Type;
  //     }

  //     await this.createNewAuditSurvey(false);
  //   }
  //   //this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
  // }
  async openAuditSurvey() {
    if (this.selectedSurvey && this.selectedSurvey.Status?.Name === 'Deleted' && this.selectedSurvey.SurveyID==null) {
      this.savedSurveyId = undefined;
      this.openAuditResponse = false;
      await this.createNewAuditSurvey(true);
      return;
    }
    if (!this.selectedSurvey || !this.selectedSurvey.SurveyID) {
      return;
    }

    this.savedSurveyId = this.selectedSurvey.SurveyID;
    this.openAuditResponse = true;
    this.newName = '';
    this.showSurveyDetails = true;
    this.isChecked = false;

    await this.createNewAuditSurvey(false);

    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.userEmail = user?.Email;
    this.surveyUserEmail = this.savedSurveyRes?.User?.Email;

    // console.log('User match:', this.userEmail === this.surveyUserEmail);

    if (this.selectedSurvey?.Status?.Name) {
      this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
    }

    // if (this.selectedSurvey?.Type) {
    //   this.selectedType = this.selectedSurvey.Type;
    // }
  }

  async getExportExcel() {
    const surveyId = this.selectedSurvey.SurveyID;
    const excelRes: any = await lastValueFrom(this.auditorService.getExportExcel(surveyId));
    // console.log(excelRes, 'worksheet');
    const toConvert = excelRes.result; //supply your full plain string here
    const file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${toConvert}`;
    // setTimeout(() => {
    fileSaverSave.saveAs(file, excelRes?.fileName);
    // }, 1300);
  }

  TabSelectionChange(index: number) {
    this.recordingTab.forEach(tab => {
      if (tab.index == index) {
        tab.isSelected = true;
        this.selectedTab = tab.name;
      } else {
        tab.isSelected = false;
      }
    });
  }

  async cancelComment(field: any, index1, index2) {
    if (this.surveySections.sectionLabelStatus == 'Submitted') {
      field.showComments = false;
      field.showAIComments = false;
    }else{
      field.showAIComments = false;
      field.showComments = false;
      const fieldGroupID = this.surveySections[index1].FieldGroup.FieldGroupID;
      const fieldName = this.surveySections[index1].FieldGroup.Fields[index2].ShortName;

      const data = {
        surveyID: this.savedSurveyId,
        fieldGroupID: fieldGroupID,
        fieldName: fieldName
      };
      let lastComment: any = await lastValueFrom(this.auditorService.GetLastSurveyComment(data));
      field.Comments = lastComment?.Response?.Data ?? ''
    }
  }
  
  isConfirmOpen(event, delOpt: boolean, action: any) 
  {
    this.isConfirmOverrideOpen = false; 
    this.isApprovalSuccessOpen = true; 
    this.saveSurvey(event, delOpt, action)
  }

   saveSurveyAI()
   {
    if (this.aiScoreSubmitted && !this.validateMandatoryComments()) 
      {
        return;
      }

     this.isConfirmOverrideOpen = true;
   }
   showMandatoryReview(): boolean 
   {
    return this.aiScoreSubmitted;
    // const status = this.interactionDetailedData?.AIReview?.trim();
    // return status === 'AI Completed' || status === 'AI Failed' || status === 'Submitted';
   }
   isMandatoryReviewField(field: any, sectionName: string): boolean {
    if (sectionName === 'HIPAA Verification') {
        return [
            'Member HIPAA verification',
            'Provider HIPAA verification'
        ].includes(field.Name);
    }
 
    if (sectionName === 'Disqualifying Event') {
        return field.Name === 'HIPAA Violation';
    }
 
    return false;
}
  validateMandatoryReviews(): boolean 
  {

    for (const section of this.surveySections) {
  
      for (const field of section.FieldGroup.Fields) 
        {
        const isMandatory = this.isMandatoryReviewField(field, section.Name);
        if (!isMandatory) 
          {
          continue;
          }
  
        const hasComment = field.Comments && field.Comments.trim().length > 0;
       
        if (!hasComment) 
            {
              field.showComments = true;
              field.showAIComments = !!field.aiComments?.trim();
             return false;
             }
      }
    }
    return true;
  }
   validateMandatoryComments(): boolean {
 
    this.mandatoryReviewSections = [];
 
    // Reset previous validation state
    for (const section of this.surveySections) {
 
      section.showMandatorySection = false;
 
      for (const field of section.FieldGroup.Fields) {
        field.showMandatoryError = false;
      }
    }
 
    // Find ALL mandatory fields that do not have human comments
    for (const section of this.surveySections) {
 
      const missingQuestions: string[] = [];
 
      for (const field of section.FieldGroup.Fields) {
 
        const isMandatory =
          this.isMandatoryReviewField(field, section.Name);
 
        if (!isMandatory) {
          continue;
        }
 
        const hasComment =
          field.Comments &&
          field.Comments.trim().length > 0;
 
        if (hasComment) {
          continue;
        }
 
        // Open the required section
        section.showMandatorySection = true;
 
        // Open human comment area
        field.showComments = true;
 
        // Show AI comments if they exist
        field.showAIComments = !!field.aiComments?.trim();
 
        // Add question to popup
        missingQuestions.push(field.Name);
      }
 
      // Add section + missing questions
      if (missingQuestions.length > 0) {
 
        this.mandatoryReviewSections.push({
          sectionName: section.Name,
          questions: missingQuestions
        });
      }
    }
 
    // At least one mandatory question is missing
    if (this.mandatoryReviewSections.length > 0) {
      this.isMandatoryReviewDialogOpen = true;
      return false;
    }
 
    return true;
  }
  ngOnDestroy(): void {
    this.saveSurveyTimeout && clearTimeout(this.saveSurveyTimeout);
  }
}

